import { render, staticRenderFns } from "./IBeaconListPage.vue?vue&type=template&id=951ce58a&scoped=true"
import script from "./IBeaconListPage.vue?vue&type=script&lang=js"
export * from "./IBeaconListPage.vue?vue&type=script&lang=js"
import style0 from "./IBeaconListPage.vue?vue&type=style&index=0&id=951ce58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951ce58a",
  null
  
)

export default component.exports